import { withRBAC } from "../../rbac";
import { LeaveTypeCreate } from "./Create";
import { LeaveTypeEdit } from "./Edit";
import { LeaveTypeList } from "./List";

export const leaveTypes = {
  list: withRBAC(LeaveTypeList, "view_hr"),
  create: withRBAC(LeaveTypeCreate, "manage_hr"),
  edit: withRBAC(LeaveTypeEdit, "manage_hr"),
  recordRepresentation: "name",
};
